/** Vizma uses Ask Vizma as its only customer-facing AI assistant. */
export function isVizmaBuild(): boolean {
  const bootstrap = window.MetabaseBootstrap as
    | { version?: { tag?: string }; "vizma-chat-origin"?: string }
    | undefined;
  return (
    /(?:^|-)vizma(?:$|-)/i.test(String(bootstrap?.version?.tag ?? "")) ||
    Boolean(bootstrap?.["vizma-chat-origin"])
  );
}
